import React from 'react';
import { useNavigate } from 'react-router-dom';
import { exitSheerIdFlow } from 'Utils/SheerIdHelpers';
import { setLocation } from 'Utils/Path';
import './ExitVerificationButton.css';

const externalVerizonLink = 'https://www.verizon.com/entertainment/pdp/fox-nation';

const ExitVerificationButton = ({ routes, hasSubscription, isBango }) => {
  const navigate = useNavigate();
  const unlinkAndNavigateUser = async () => {
    await exitSheerIdFlow(!isBango);
    /* 
      if hasSubscription is false and isBango, redirect to https://www.verizon.com/entertainment/pdp/fox-nation (NATCOM-931)
      if hasSubscription is true, let the browser handle navigation. This allows the Akamai redirect 
      to take effect and redirect from '/' to '/featured' for the active subscriber.
    */
    if (!hasSubscription && isBango) {
      setLocation(externalVerizonLink, 'href');
    } else if (!!hasSubscription) {
      setLocation(routes.welcome);
    } else {
      navigate(routes.signupPlans);
    }
  };
  return (
    <button onClick={unlinkAndNavigateUser} className="exitVerificationButton">
      <img
        src="/account/static/images/cross-mark-white.svg"
        width="17"
        height="17"
        className="exitVerificationIcon"
        alt="exit"
      />
      Exit Verification
    </button>
  );
};

export default ExitVerificationButton;
